import React, { useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
AOS.init();

function Projects() {
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => {
    setShowModal(true);
  };
  const imgModal = require("../demo/Demo PsyTun.mp4");
  const { t } = useTranslation();
  return (
    <div className="section" id="projects">
      <div className="content has-text-centered">
        <h1 className="block is-size-1 has-text-centered underline">
          <span>{t("tr.projects")}</span>
        </h1>
      </div>

      <div className="columns is-multiline">
        <div className="column is-5 is-offset-1">
          <div
            className="card cardDark carProject"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <div className="card-image p-4 ">
              <figure className="image is-480*250">
                <img
                  src={require("../images/psyApp.png")}
                  alt="Placeholder"
                  style={{ borderRadius: "0.5rem" }}
                />
              </figure>
            </div>
            <div className="card-content">
              <p className="title is-4 titleProject">PsyTun</p>

              <div className="content">
                <p
                  className="subtitle has-text-centered has-text-weight-semibold is-size-5"
                  style={{ lineHeight: "2rem" }}
                >
                  {t("description.psyTun")}
                </p>
              </div>
              <div className="buttons is-centered ">
                <button
                  className="button btnDemo"
                  onClick={(event) => handleShow()}
                >
                  Demo
                </button>
              </div>
            </div>
            <footer className="card-footer">
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                React
              </p>
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                Mongodb
              </p>
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                Express
              </p>
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                Node
              </p>
            </footer>
          </div>
        </div>
        <div className="column is-5">
          <div
            className="card cardDark carProject"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <div className="card-image p-4 ">
              <figure className="image is-480*250">
                <img
                  src={require("../images/haymosApp.png")}
                  alt="Placeholder"
                  style={{ borderRadius: "0.5rem" }}
                />
              </figure>
            </div>
            <div className="card-content">
              <p className="title is-4 titleProject">Haymos</p>

              <div className="content">
                <p
                  className="subtitle has-text-centered has-text-weight-semibold is-size-5"
                  style={{ lineHeight: "2rem" }}
                >
                  {t("description.haymos")}
                </p>
              </div>
              <div className="buttons is-centered ">
                <a href="https://haymos.tn/" target="_black">
                  <button className="button  btnDemo is-inverted ">Demo</button>
                </a>
              </div>
            </div>
            <footer className="card-footer">
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                React
              </p>
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                Bulma
              </p>
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                Email Js
              </p>
            </footer>
          </div>
        </div>
        <div className="column is-5 is-offset-1">
          <div
            className="card cardDark carProject"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <div className="card-image p-4 ">
              <figure className="image is-480*250">
                <img
                  src={require("../images/carprice.png")}
                  alt="Placeholder"
                  style={{ borderRadius: "0.5rem" }}
                />
              </figure>
            </div>
            <div className="card-content">
              <p className="title is-4 titleProject">Car Price Prediction</p>

              <div className="content">
                <p
                  className="subtitle has-text-centered has-text-weight-semibold is-size-5"
                  style={{ lineHeight: "2rem" }}
                >
                  {t("description.carPrice")}
                </p>
              </div>
              <div className="buttons is-centered ">
                <a
                  target="_black"
                  href="https://montassar1999-car-price-prediction-app-3l6l76.streamlitapp.com/"
                >
                  <button className="button btnDemo">Demo</button>
                </a>
              </div>
            </div>
            <footer className="card-footer">
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                Python
              </p>
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                Sickit-learn
              </p>
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                Streamlit
              </p>
            </footer>
          </div>
        </div>
        <div className="column is-5 ">
          <div
            className="card cardDark carProject"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <div className="card-image p-4 ">
              <figure className="image is-480*250">
                <img
                  src={require("../images/heart.png")}
                  alt="Placeholder"
                  style={{ borderRadius: "0.5rem" }}
                />
              </figure>
            </div>
            <div className="card-content">
              <p className="title is-4 titleProject">Heart Disease Test</p>

              <div className="content">
                <p
                  className="subtitle has-text-centered has-text-weight-semibold is-size-5"
                  style={{ lineHeight: "2rem" }}
                >
                  {t("description.heartDisease")}
                </p>
              </div>
              <div className="buttons is-centered ">
                <a target="_black" href="https://heartdisease.onrender.com/">
                  <button className="button btnDemo">Demo</button>
                </a>
              </div>
            </div>
            <footer className="card-footer">
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                Python
              </p>
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                Flask
              </p>
              <p className="card-footer-item has-text-grey has-text-weight-bold">
                Sickit-learn
              </p>
            </footer>
          </div>
        </div>
      </div>
      <div className={`modal ${showModal ? "is-active" : ""}`}>
        <div className="modal-background"></div>
        <div
          className="modal-content"
          style={{ width: "1200px", height: "800px" }}
        >
          <figure className="image is-16by9">
            <iframe
              className="has-ratio"
              src={imgModal}
              frameBorder="0"
              allowFullScreen
              title="Demo PsyTun"
            ></iframe>
          </figure>
        </div>
        <button
          className="modal-close is-large"
          aria-label="close"
          onClick={handleClose}
        ></button>
      </div>
    </div>
  );
}

export default Projects;
